import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLaptop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#1a78c0",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laptop",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M20.5312 14.1328V4.89062C20.5312 4.7039 20.4945 4.51901 20.423 4.3465C20.3516 4.17399 20.2468 4.01724 20.1148 3.88521C19.9828 3.75317 19.826 3.64844 19.6535 3.57698C19.481 3.50553 19.2961 3.46875 19.1094 3.46875H4.89062C4.7039 3.46875 4.51901 3.50553 4.3465 3.57698C4.17399 3.64844 4.01724 3.75317 3.88521 3.88521C3.75317 4.01724 3.64844 4.17399 3.57698 4.3465C3.50553 4.51901 3.46875 4.7039 3.46875 4.89062V14.1328H20.5312Z",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M22.542 18.5321C22.6381 18.7486 22.6787 18.9857 22.66 19.2218C22.6412 19.458 22.5638 19.6857 22.4347 19.8843C22.3056 20.083 22.1289 20.2462 21.9206 20.3591C21.7124 20.4721 21.4793 20.5313 21.2424 20.5312H2.75799C2.5211 20.5313 2.28795 20.4721 2.07972 20.3591C1.8715 20.2462 1.69481 20.083 1.56569 19.8843C1.43657 19.6857 1.35913 19.458 1.34039 19.2218C1.32166 18.9857 1.36222 18.7486 1.4584 18.5321L3.46893 14.1328H20.5314L22.542 18.5321Z",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M10.5781 17.6875H13.4219",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgLaptop;
